import React from 'react';
import {
  AppNotificationType,
  type AppNotification as AppNotificationDef,
} from './types';
import { EditorNotSupportedNotification } from './editor-not-supported/editor-not-supported-notification';

export interface AppNotificationProps {
  notification: AppNotificationDef | null;
}

export function AppNotification({ notification }: AppNotificationProps) {
  if (notification?.type === AppNotificationType.EditorNotSupported) {
    const { appName, editorType } = notification.data;
    return (
      <EditorNotSupportedNotification
        appName={appName}
        editorType={editorType}
      />
    );
  }

  return null;
}
